import { VisitAndAppointmentStatus } from '@dreryk/egabinet-visit-frontend-api';

import { createSingleInterpolatedTranslationKey, TranslatableText, useTranslate } from '@dreryk/react-common';

import { appointmentsTranslationKeys } from '../../../translations';
import { getVisitAndAppointmentStatusesFilterCount } from '../AppointmentsFilterPanel/fields/VisitAndAppointmentStatusField/VisitAndAppointmentStatusField.utils';

const VISIT_AND_APPOINTMENT_STATUS_CHIP_FILTER_SEPARATOR = ', ';

export const useVisitAndAppointmentStatusFilterLabel = (
   visitAndAppointmentsStatuses: VisitAndAppointmentStatus[]
): TranslatableText => {
   const translate = useTranslate();

   if (visitAndAppointmentsStatuses.length === getVisitAndAppointmentStatusesFilterCount()) {
      return createSingleInterpolatedTranslationKey(
         appointmentsTranslationKeys.visitAndAppointmentStatusFilter.filterLabel,
         'statuses',
         translate(appointmentsTranslationKeys.visitAndAppointmentStatusFilter.filterLabelAll)
      );
   }
   return createSingleInterpolatedTranslationKey(
      appointmentsTranslationKeys.visitAndAppointmentStatusFilter.filterLabel,
      'statuses',
      visitAndAppointmentsStatuses
         .map((status) => {
            return translate(appointmentsTranslationKeys.statusCode[status]);
         })
         .join(VISIT_AND_APPOINTMENT_STATUS_CHIP_FILTER_SEPARATOR)
   );
};
